import { CAMPAIGN_AUDIENCE_DATA } from "src/app/ReportGenerator/utils/variables";
import { SocialProvider } from "src/types";
import { METRIC_SIZES } from "../utils/variables";

export const getGridElementSize = (
  id,
  provider,
  hiddenGridElements,
  format,
  metricType,
  element,
) => {
  switch (provider) {
    case "metadata":
      const field = hiddenGridElements.find((item) => item.label === id);

      return field.type === "text"
        ? { i: metricType, w: format.cols, h: 2 }
        : { i: metricType, w: format.cols / 2, h: 1 };

    case SocialProvider.Instagram:
    case SocialProvider.TikTok:
    case SocialProvider.Youtube:
    case SocialProvider.Snapchat:
    case SocialProvider.Twitter:
    case SocialProvider.Facebook:
      return METRIC_SIZES.find((item) => item.i === metricType);

    case "audience-data":
      return CAMPAIGN_AUDIENCE_DATA.find((item) => item.value === metricType);

    case "overlap-platform":
      return { w: 4, h: 3 };

    case "overlap-chart":
      return { w: 8, h: 3 };

    case "overlap-creator":
      return { w: 12, h: 2 };

    case "comments":
      return { w: format.cols / 2, h: 5 };

    case "creator-insights":
      return { w: 4, h: 3 };

    case "header":
      return { w: format.cols, h: 1 };

    case "creator":
    case "paragraph":
      return { w: format.cols, h: 2 };

    case "glossary-two":
      return { w: format.cols, h: 3 };

    case "text":
      return { w: format.cols / 3, h: 2 };

    case "post-data":
      return { w: format.cols / 4, h: 2 };

    case "publication":
    case "top-publication":
      return { w: format.cols / 3, h: 7 };

    case "sentiment-analysis":
      return { w: format.cols / 4, h: 2 };

    case "glossary":
    case "summary-learnings":
      return { w: 12, h: 15 };

    case "table-summary":
      return { w: 12, h: element?.data?.height };

    default:
      return {};
  }
};
